<section id="content" *ngIf="lang">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>{{lang.supportTicket}}</h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>
            <a [routerLink]="'/super/'+AppFrontRoutes.TICKET_LIST">{{lang.supportTicket}}</a>
          </li>
        </ul>
      </div>
    </div>

    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body">
              <div role="tabpanel">

                <div class="row p-10">

                  <!-- <div class="col-sm-3">
                    <div class="social-icons">
                      <a class="plus-add" [routerLink]="'/'+AppFrontRoutes.ADMIN_TICKET_CREATE">
                        <i class="fa fa-plus"></i>
                      </a>
                    </div>
                  </div> -->

                  <div class="col-sm-3">
                    <select class="form-control" (change)="datatableFilterAction()" [(ngModel)]="filter1">
                        <option value>{{lang.all}}</option>
                        <option value="Open">{{lang.openStatus}}</option>
                        <option value="closed">{{lang.closedStatus}}</option>
                    </select>
                  </div>

                  <div class="col-sm-3">
                    <select class="form-control" (change)="datatableFilterAction()" [(ngModel)]="filter2">
                      <option value>{{lang.all}}</option>
                      <option value="1">{{lang.viewed}}</option>
                      <option value="2">{{lang.unViewed}}</option>
                  </select>
                  </div>

                  <div class="col-sm-3">
                    <select class="form-control" (change)="datatableFilterAction()" [(ngModel)]="filter3">
                      <option value>{{lang.all}}</option>
                      <option value="1">{{lang.replied}}</option>
                      <option value="2">{{lang.noReplied}}</option>
                    </select>
                  </div>

                </div>

                <div class="form-group">
      
                  <table datatable [dtOptions]="datatableOptions" [dtTrigger]="datatableTrigger" class="table-striped table-sm row-border hover">
                    
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>{{lang.ticketNo}}</th>
                        <th>Company Name</th>
                        <th>{{lang.category}}</th>
                        <th>{{lang.created}}</th>
                        <th>{{lang.status}}</th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th>{{lang.action}}</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr *ngFor="let ticket of tickets let i = index" [ngClass]="{'notreplied' : (ticket.reply_status == 2), 'notviewed' : (ticket.view_status == 2)}">
                        <td>{{i+1}}</td>
                        <td><a [routerLink]="['/super/'+AppFrontRoutes.ADMIN_TICKET_VIEW+'/'+ticket.ticket_id]" class="btn btn-primary">{{ticket.ticket_no}}</a></td>
                        <td>{{ticket.company}}</td>
                        <td>{{categories[ticket.category_id].description}}</td>
                        <td>{{ticket.created * 1000 | date:'dd-MM-yyyy hh:mm:ss':this.timezone}}</td>
                        <td>
                          <button type="button" class="btn btn-success" *ngIf="ticket.status == 1">{{lang.open}}</button>
                          <button type="button" class="btn btn-danger" *ngIf="ticket.status == 2">{{lang.closed}}</button>
                        </td>
                        <td>{{ticket.status}}</td>
                        <td>{{ticket.view_status}}</td>
                        <td>{{ticket.reply_status}}</td>
                        <td>
                          <div class="btn-group dropup">
                            
                            <button type="button" class="btn btn-info dropdown-toggle circle_btn" data-toggle="dropdown"
                              aria-expanded="false"><i class="fa fa-tasks"></i></button>

                            <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                              <li><a [routerLink]="['/super/'+AppFrontRoutes.ADMIN_TICKET_VIEW+'/'+ticket.ticket_id]" class="blue_action"><i class="glyphicon glyphicon-eye-open"></i> {{lang.viewTicket}}</a></li>
                              <li (click)="closeTicket(ticket.ticket_id)" *ngIf="ticket.status == 1"><a class="red_action"><i class="glyphicon glyphicon-stop"></i> {{lang.closeTicket}}</a></li>
                              
                            </ul>
                          </div>
                        </td>
                      </tr>
                    </tbody>

                  </table>
                </div>
              </div>
            
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>